export default [
    {
        path: '/accreditation-agreed',
        name: 'Accreditation_agreed',
        component: () => import("@/pages/Founders/AccreditationAgreed"),
        meta:{
            needContact: true,
            roles: ['FOUNDER_ROLE', 'CO_ROLE', 'ADMIN_ROLE'],
        }
    }
]